<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Gl_backbutton />
                Пользователи
            </div>
            <div class="content-inner">
                <div class="btn_add" @click="$router.push('/users/new')">Новый пользователь</div>
                <table>
                    <tr>
                        <th>ID</th>
                        <th>Email</th>
                        <th>Фамилия</th>
                        <th>Имя</th>
                        <th>Отчество</th>
                        <th>Роль в системе</th>
                        <th></th>
                    </tr>
                    <tr v-for="user in user_data" :key="user.id">
                        <td>{{ user.id }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.surname }}</td>
                        <td>{{ user.name }}</td>
                        <td>{{ user.third_name }}</td>
                        <td>{{ roles[user.role_id] }}</td>
                        <td>
                            <div class="btn_for_table buttons_inline" @click="$router.push('/users/show/'+user.id)" >Просмотр</div>
                            <div class="btn_for_table_delete buttons_inline" @click="delete_user(user.id)">Удалить</div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'Users',
    components: {
        Success, Error
    },
    mixins: [
        require('../../mixins/users/usersMixins.vue')
    ],
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            user_data: {},
            roles: {
                1: 'Администратор',
                2: 'Сборщик'
            }
        }
    },
    created() {
        this.users()
    }
}
</script>


<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>